
import React from 'react';
import Layout from '@/components/layout/Layout';
import HarvestList from '@/components/harvests/HarvestList';

const Harvests: React.FC = () => {
  return (
    <Layout>
      <HarvestList />
    </Layout>
  );
};

export default Harvests;
